import React from 'react';
import plural from 'plural-ru';
import { TooltipWithTriggerIcon } from '@alfa-retail-react/components';

import { WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';
import { FormatUtils } from 'app/utils/FormatUtils';
import { KkgCardProduct } from 'app/model/product/KkgCardProduct';
import { FieldSet } from 'app/component/fieldset/FieldSet';
import { CardOrder } from 'app/model/CardOrder';
import { useIsDesktop } from 'app/utils/useWindowType';

export interface KkgProductDetailProps {
    kkgCardProduct: KkgCardProduct;

    order: CardOrder;
}

export const KkgProductDetails = ({
    kkgCardProduct,
    order,
}: KkgProductDetailProps) => {
    const insurance = kkgCardProduct.insurance.find(
        ({ code }) => code === order.insuranceProductCode,
    );
    const [isDesktop] = useIsDesktop();
    const {
        commissionAmount,
        currency,
        graceRate,
        graceTerm,
        maxAmount,
        rate,
        restAmountRate,
    } = kkgCardProduct;

    return (
        <>
            <FieldSet
                className={'productDetailsFieldSet'}
                fieldsProps={[
                    {
                        className: 'limit',
                        title: 'Кредитный лимит',
                        value: (
                            <span>
                                до {FormatUtils.toIntegerString(maxAmount)}{' '}
                                <span className="currency">{currency}</span>
                            </span>
                        ),
                        isVisible: !order.amount,
                    },
                    {
                        className: 'limit',
                        title: 'Кредитный лимит',
                        value: (
                            <span className={WEB_VISOR_HIDE}>
                                {!!order.amount &&
                                    FormatUtils.toIntegerString(
                                        order.amount,
                                    )}{' '}
                                <span className="currency">{currency}</span>
                            </span>
                        ),
                        isVisible: !!order.amount,
                    },
                    {
                        className: 'graceTerm',
                        title: 'Льготный период',
                        value: `${plural(
                            graceTerm,
                            '%d день',
                            '%d дня',
                            '%d дней',
                        )}`,
                        tooltip: () => (
                            <TooltipWithTriggerIcon
                                title="Льготный период"
                                content={
                                    'Льготный период на все операции, включая снятие наличных'
                                }
                                isDesktop={isDesktop}
                            />
                        ),
                    },
                    {
                        className: 'graceRate',
                        title: 'Ставка в льготном периоде',
                        value: `от ${FormatUtils.toDecimalString(
                            graceRate,
                            5,
                        )} %`,
                        tooltip: () => (
                            <TooltipWithTriggerIcon
                                title="Ставка в льготном периоде"
                                isDesktop={isDesktop}
                                content={
                                    'Ставка в льготном периоде применяется при условии полного погашения суммы задолженности. ' +
                                    'Если условие не выполнено, банк пересчитает проценты на сумму задолженности по ставке по кредиту с начала льготного периода'
                                }
                            />
                        ),
                    },
                    {
                        className: 'rate',
                        title: 'Ставка по кредиту',
                        value: `${FormatUtils.toPercentString(rate)} %`,
                    },
                    {
                        className: 'commission',
                        title: 'Обслуживание карты',
                        value: (
                            <span>
                                {FormatUtils.toDecimalString(commissionAmount)}{' '}
                                <span className="currency">{currency}/мес</span>
                            </span>
                        ),
                        tooltip: () => (
                            <TooltipWithTriggerIcon
                                title="Обслуживание карты"
                                isDesktop={isDesktop}
                                content={
                                    <div>
                                        Бесплатное обслуживание карты:
                                        <ul>
                                            <li>
                                                пока вы не начали пользоваться
                                                картой
                                            </li>
                                            <li>
                                                при оплате картой своими
                                                средствами не менее 100 BYN/мес
                                            </li>
                                        </ul>
                                    </div>
                                }
                            />
                        ),
                    },
                    {
                        className: 'restRate',
                        title: 'Ставка на остаток собственных средств',
                        value: `${FormatUtils.toPercentString(
                            restAmountRate,
                        )} %`,
                    },
                    //https://projects.alfabank.by/browse/CC2C-199
                    // {
                    //     className: 'grantTerm',
                    //     title: 'Срок предоставления',
                    //     value: kkgCardProduct.grantTerm,
                    // }
                    {
                        className: 'insurance',
                        title: 'Страховой взнос',
                        value: (
                            <span>
                                {!!insurance?.amount &&
                                    FormatUtils.toIntegerString(
                                        insurance?.amount,
                                    )}{' '}
                                <span className="currency">
                                    {insurance?.currency}
                                </span>
                            </span>
                        ),
                        isVisible: !!insurance,
                    },
                ]}
            />
        </>
    );
};
